export const viewConstants = {
    SET_VIEW_STATE: 'VIEW_SET_VIEW_STATE',
    SET_FARMER_VIEW_STATE: 'VIEW_SET_FARMER_VIEW_STATE',
    SET_INFO_PANEL_STATE: 'VIEW_SET_INFO_PANEL_STATE',
};
